import {
  Card,
  Stack,
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import { FEATURE } from "src/util/enums";
import { useAccess } from "src/hooks/useAccess.hook";
import Page from "../Page";
import { BaseTable } from "../BaseTable/BaseTable";
import { chargerPointColumns, tabsToShow } from "./charger.constants";
import { useDispatch, useSelector } from "react-redux";
import { dialogSlice } from "src/store/dailog/dailog.slice";
import { RemoteOperationModal } from "./RemoteOperation/RemoteOperationModal";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import { tabsCurrentlyOpenedForSlice } from "src/store/tabsOpened/tabsOpened.slice";
import { CommonSearchbar } from "src/layouts/dashboard/Searchbar";
import ExportCSV from "../ExportCsv/ExportCSV";
import { useSelectedTeam } from "src/hooks/useSelectedTeam";
import { ChargerLimitModal } from "./ChargerLimitModal";
import { useFetchOnDemand, useList, useMutate } from "src/hooks/useFetch.hook";
import { useQuery } from "@tanstack/react-query";
import { fetchWithError } from "src/react-query/fetchWithError";
import { initiateChargerLicenseSaleUrl } from "src/react-query/endPoints";
import { queryKeys } from "src/react-query/queryKeys";
import { selector } from "src/react-query/select";
import { is } from "src/util/is";
import { debounceFunc } from "src/utils/helper";
import { Icon } from "@iconify/react";
import AlertCircleFill from "@iconify/icons-eva/alert-circle-fill";
import alertTriangleFill from "@iconify/icons-eva/alert-triangle-fill";
import closeFill from "@iconify/icons-eva/close-fill";
import clockOutline from "@iconify/icons-eva/clock-outline";
import { TabContext, TabPanel } from "@mui/lab";
import { RootTabItemStyles, RootTabStyle } from "src/theme/overrides/Tabs";
import { ChargerLicenseModal } from "src/common/components/ChargerLicenseModal";
import { StripePaymentModule } from "src/common/components/StripePaymentModule";
import { PaytmPaymentModule } from "src/common/components/PaytmPaymentModule";
import { RenewalChargerTable } from "src/common/components/RenewalChargerTable";

export default function ChargerList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { teamId, teamName, teamType } = useSelectedTeam();
  const hasCreateAccess = useAccess(FEATURE.CHARGER, "C");
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
  const isReadOnly = useAccess(FEATURE.CHARGER, "R");
  const isViewOnly = useAccess(FEATURE.CHARGER, "V");
  const {
    data: { chargers: chargers = [], totalRecords = 0 } = {},
    isLoading, mutate: fetchData
  } = useFetchOnDemand("chargerList", false, false);
  
  const { data: { charger_license_payment_config } = {} } = useQuery(
    queryKeys.chargerLicenseConfig(teamId),
    fetchWithError,
    {
      enabled: !is.empty(teamId) && teamType !== 'P',
      select: selector,
    }
  );
  
  const { open, data } = useSelector(({ dialog }) => dialog);
  const user = useSelector((state) => state.auth.user);
  const isTeamCompany = teamType === "T";
  const { mutate: initiateLicenseSale } = useMutate("chargerLicenseConfig", {}, false);
  const [sortModel, setSortModel] = useState([
    { field: "status", sort: "asc" },
  ]);
  const [tableData, setTableData] = useState();
  const [licenseModalOpen, setLicenseModalOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState("expiredLicenses");
  const [chargerLicensePurchaseModalOpen, setChargerLicensePurchaseModalOpen] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const [selectedRenewalChargers, setSelectedRenewalChargers] = useState([]);
  const [renewModalOpen, setRenewModalOpen] = useState(false);
  
  const { data: licenseDetailsData, isFetching: licenseDetailsFetching } = useList(
    "licensesDetails",
    true,
    {}
  );
  const expiredLicenses = licenseDetailsData?.chargersWithoutLicenseCount || 0;
  const upcomingExpiringLicenses = licenseDetailsData?.chargersWithUpcomingLicenseExpiryCount || 0;
  const chargersWithoutLicense = licenseDetailsData?.chargersWithoutLicense || [];
  const chargersWithUpcomingLicenseExpiry = licenseDetailsData?.chargersWithUpcomingLicenseExpiry || [];

  const handleClose = () => {
    dispatch(dialogSlice.actions.setDialog(false));
  };

 const toggleChargerLicensePurchaseModal = () => setChargerLicensePurchaseModalOpen((prev) => !prev);

  // License Modal Handlers
  const handleLicenseModalOpen = () => {
    setLicenseModalOpen(true);
  };

  const handleLicenseModalClose = () => {
    setLicenseModalOpen(false);
  };

  const handleLicenseCancel = () => {
    setLicenseModalOpen(false);
    setSelectedRenewalChargers([]);
  };

  const handleViewChargepoint = (charge_box_pk) => {
    dispatch(
      tabsCurrentlyOpenedForSlice.actions.setTabsOpened({
        detailsId: charge_box_pk,
        tabOpenedFor: 'charger',
        tabOpened: 'general',
      })
    );
    navigate(`/charger/${charge_box_pk}`);
    handleLicenseModalClose();
  };

  const handleTabChange = (_e, tab) => {
    setSelectedTab(tab);
    setSelectedRenewalChargers([]);
  };

  const handlePurchase = (payload) => {
    initiateLicenseSale(
      {
        url: initiateChargerLicenseSaleUrl,
        method: 'POST',
        body: {
          team_id: teamId,
          user_id: user?.id,
          ...payload,
        },
      },
      {
        onSuccess: (data) => {
          setChargerLicensePurchaseModalOpen(false);
          setRenewModalOpen(false);
          if (data?.checkoutUrl) {
            window.location.href = data.checkoutUrl;
          } else {
            setPaymentData({ ...data, amount: payload.total_cost });
          }
        },
      }
    );
  };
    

  useEffect(() => {
    let data = [...chargers];
    setTableData(data);
  }, [chargers]);

  const rowOrCellClickRedirect = ({ id }) => {
    // if (isReadOnly) return;
    dispatch(
      tabsCurrentlyOpenedForSlice.actions.setTabsOpened({
        detailsId: id,
        tabOpenedFor: "charger",
        tabOpened: "general",
      })
    );
    navigate(`/charger/${id}`);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPaginationModel({ page: 0, pageSize: newPageSize });
  };

  const handlePageChange = (newPage) => {
    setPaginationModel(prev => ({ page: newPage, pageSize: prev.pageSize }));
  };

  const [refetchTrigger, setRefetchTrigger] = useState(0);
  const refetchChargerList = useCallback(() => setRefetchTrigger((k) => k + 1), []);

  useEffect(() => {
    fetchData({ page: paginationModel.page, pageSize: paginationModel.pageSize, search: searchValue });
  }, [paginationModel.page, paginationModel.pageSize, searchValue, refetchTrigger]);


  const handleCreateCharger = () => {
    dispatch(
      tabsCurrentlyOpenedForSlice.actions.setTabsOpened({
        detailsId: "",
        tabOpenedFor: "charger",
        tabOpened: "general",
      })
    );
    navigate("new");
  };

  const getActions = () => {
    if (!hasCreateAccess) return [];

    const actionBtns = isTeamCompany ? [{
        text: "Purchase Charger License",
        action: toggleChargerLicensePurchaseModal,
        icon:"eva:shopping-cart-fill"
     }] : [];

    return [...actionBtns, {
      text: "Add Charge Point",
      action: handleCreateCharger,
    }];
  };

  return (
    <Page
      title="Charge Points | Smart-CMS"
      actions={getActions()}
      sx={{ p: 2, mt: -3 }}
    >
      {/* License Status Banner */}
      {isViewOnly && (expiredLicenses > 0 || upcomingExpiringLicenses > 0) && (
        <Box sx={{ mt: 2, mb: 3 }}>
          <Box
            sx={(theme) => ({
              bgcolor: theme.palette.mode === 'dark' ? theme.palette.background.paper : '#ffffff',
              border: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.divider : '#E0E0E0'}`,
              borderRadius: '16px',
              p: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              boxShadow: theme.palette.mode === 'dark'
                ? '0px 2px 12px rgba(37, 99, 235, 0.12)'
                : '0px 2px 4px rgba(0,0,0,0.1)',
              width: '100%',
            })}
          >
            {/* LEFT SIDE (All text + icons) */}
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
              <Box>
                {/* Title */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                  <Icon icon="eva:file-text-outline" width={24} height={24} />
                  <Typography variant="h6" sx={(theme) => ({ fontWeight: 600, color: theme.palette.mode === 'dark' ? theme.palette.primary.main : '#333' })}>
                    License Status
                  </Typography>
                </Box>

                {/* Messages */}
                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                  {expiredLicenses > 0 && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Icon icon={alertTriangleFill} color={theme => theme.palette.warning.main} width={22} />
                      <Typography variant="body2" sx={theme => ({ color: theme.palette.error.main })}>
                        {expiredLicenses} License need immediate attention
                      </Typography>
                    </Box>
                  )}

                  {upcomingExpiringLicenses > 0 && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Icon icon={clockOutline} color={theme => theme.palette.warning.main} width={22} />
                      <Typography variant="body2" sx={theme => ({ color: theme.palette.warning.main })}>
                        {upcomingExpiringLicenses} Upcoming license expiry
                      </Typography>
                    </Box>
                  )}
                </Box>

                {/* Support contact */}
                <Box sx={{ mt: 1.5 }}>
                  <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                    Need help? Contact our support team:
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 0.5, flexWrap: "wrap" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                      <Icon icon="eva:email-outline" width={16} />
                      <Typography variant="caption">
                        <a href="mailto:zynkasupport@zynka.ai" style={{ color: "inherit", textDecoration: "none" }}>
                          zynkasupport@zynka.ai
                        </a>
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                      <Icon icon="eva:phone-outline" width={16} />
                      <Typography variant="caption">+919429693773</Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>

            {/* RIGHT SIDE BUTTON */}
            <Button
              variant="outlined"
              size="small"
              onClick={handleLicenseModalOpen}
              sx={{ textTransform: "none", fontWeight: 500, minWidth: 140 }}
            >
              View Details
            </Button>
          </Box>
        </Box>
      )}

      <Card sx={{ p: 2, mt: 2 }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <CommonSearchbar
            placeholder="Search"
            searchFunc={(e) =>
              debounceFunc(() => {
                setPaginationModel({ page: 0, pageSize: 10 });
                setSearchValue(e.target.value);
              }, 800)()}
          />
          <ExportCSV
            rows={tableData || []}
            columns={chargerPointColumns(isReadOnly, refetchChargerList)}
            csvMorphemes="chargers"
            csvColumns={chargerPointColumns(isReadOnly, refetchChargerList)}
          />
        </Stack>
        <BaseTable
          rows={tableData ?? []}
          columns={chargerPointColumns(isReadOnly, refetchChargerList)}
          loading={isLoading}
          getRowId={(row) => row.chargepoint_pk}
          rowOrCellClickRedirect={rowOrCellClickRedirect}
          pageSize={pageSize}
          sortModel={sortModel}
          onSortModelChange={(model) => setSortModel(model)}
          isReadOnly={isReadOnly}
          showExportCsvBtn={false}
          csvMorphemes="chargers"
          csvColumns={chargerPointColumns(isReadOnly, refetchChargerList)}
          rowHeight={80}
          paginationModel={paginationModel}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          totalRows={totalRecords || 0}
          serverRowFetcher={true}
        />
      </Card>
      {open && data?.modalType === "remoteoperation" && (
        <RemoteOperationModal
          open={open}
          chargerId={data?.id}
          chargerPk={data?.pk}
          onClose={handleClose}
        />
      )}
      {open && data === "ChargerLimitModal" && (
        <ChargerLimitModal open={open} onClose={handleClose} />
      )}

            <ChargerLicenseModal
              open={chargerLicensePurchaseModalOpen}
              onClose={() => setChargerLicensePurchaseModalOpen(false)}
              onConfirm={(payload) => handlePurchase(payload)}
              charger_license_payment_config={charger_license_payment_config}
              teamName={teamName}
             />

            <ChargerLicenseModal
              open={renewModalOpen}
              onClose={() => {
                setRenewModalOpen(false);
                setLicenseModalOpen(true);
                setSelectedRenewalChargers([]);
              }}
              onConfirm={(payload) => handlePurchase(payload)}
              charger_license_payment_config={charger_license_payment_config}
              teamName={teamName}
              chargersToRenew={selectedRenewalChargers}
            />

            <StripePaymentModule
              open={paymentData?.for === 'stripe'}
              onClose={() => setPaymentData(null)}
              clientId={paymentData?.clientId}
              paymentId={paymentData?.paymentId}
              returnUrl={paymentData?.return_url}
              onError={() => setPaymentData(null)}
            />

            <PaytmPaymentModule
              open={paymentData?.for === 'paytm'}
              onClose={() => setPaymentData(null)}
              txnId={paymentData?.txnToken}
              orderId={paymentData?.orderId}
              merchantId={paymentData?.merchantId}
              amount={paymentData?.amount}
              onError={() => setPaymentData(null)}
            />

      {/* License Details Modal */}
      <Dialog
        open={licenseModalOpen}
        onClose={handleLicenseCancel}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Icon icon={alertTriangleFill} style={{ color: '#FF9800', fontSize: 20 }} />
            <Typography variant="subtitle1" fontWeight={600}>
              License Management
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, ml: 1 }}>
              <Box sx={{ px: 1, py: 0.25, borderRadius: 1, bgcolor: 'error.lighter', color: 'error.dark', fontSize: 12, fontWeight: 600 }}>
                {expiredLicenses} Expired
              </Box>
              <Box sx={{ px: 1, py: 0.25, borderRadius: 1, bgcolor: 'warning.lighter', color: 'warning.dark', fontSize: 12, fontWeight: 600 }}>
                {upcomingExpiringLicenses} Upcoming
              </Box>
            </Box>
          </Box>
          <Typography variant="caption" color="text.secondary" display="block" mt={0.5}>
            Select chargers to renew or view their details
          </Typography>
          <IconButton
            onClick={handleLicenseCancel}
            size="small"
            sx={{ position: 'absolute', top: 12, right: 12 }}
          >
            <Icon icon={closeFill} />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ px: 0, pt: 0 }}>
          {licenseDetailsFetching ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Icon icon={clockOutline} style={{ fontSize: 20, color: '#637381' }} />
                <Typography color="text.secondary">Loading license details...</Typography>
              </Box>
            </Box>
          ) : (
            <TabContext value={selectedTab}>
              <Box sx={{ width: { xs: '800px', sm: '100%' }, display: 'flex', justifyContent: 'center', borderBottom: '1px solid', borderColor: 'divider' }}>
                <RootTabStyle
                  indicatorColor="transparent"
                  centered
                  length={tabsToShow.length}
                  onChange={handleTabChange}
                >
                  {tabsToShow.map((tab) => (
                    <RootTabItemStyles
                      key={tab.value}
                      value={tab.value}
                      label={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                          {tab.label}
                          <Box
                            component="span"
                            sx={{
                              px: 0.75, borderRadius: 10, fontSize: 11, fontWeight: 700, lineHeight: '18px',
                              bgcolor: tab.value === 'expiredLicenses' ? 'error.main' : 'warning.main',
                              color: 'white',
                            }}
                          >
                            {tab.value === 'expiredLicenses' ? expiredLicenses : upcomingExpiringLicenses}
                          </Box>
                        </Box>
                      }
                    />
                  ))}
                </RootTabStyle>
              </Box>
              <TabPanel value="expiredLicenses" sx={{ width: { xs: '800px', sm: '100%' }, px: 2, pt: 1.5 }}>
                <RenewalChargerTable
                  rows={chargersWithoutLicense}
                  loading={licenseDetailsFetching}
                  onSelectionChange={setSelectedRenewalChargers}
                  onView={handleViewChargepoint}
                />
              </TabPanel>
              <TabPanel value="upcomingLicensesExpiry" sx={{ width: { xs: '800px', sm: '100%' }, px: 2, pt: 1.5 }}>
                <RenewalChargerTable
                  rows={chargersWithUpcomingLicenseExpiry}
                  loading={licenseDetailsFetching}
                  onSelectionChange={setSelectedRenewalChargers}
                  onView={handleViewChargepoint}
                />
              </TabPanel>
            </TabContext>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid', borderColor: 'divider' }}>
          <Button onClick={handleLicenseCancel} variant="outlined" color="inherit">
            Close
          </Button>
          {isTeamCompany && (
            <Button
              variant="contained"
              disableElevation
              disabled={selectedRenewalChargers.length === 0}
              onClick={() => {
                handleLicenseModalClose();
                setRenewModalOpen(true);
              }}
            >
              Renew Selected ({selectedRenewalChargers.length})
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Page>
  );
}
